import React from 'react';

import Button from '@components/common/Button/Button';
import useTranslateLpc from '@components/common/hooks/useTranslateLpc';
import Text from '@components/common/Text/Text';

import css from './Confirmation.module.scss';

type ConfirmationProps = {
    onCloseModal: () => void;
};

const Confirmation = ({ onCloseModal }: ConfirmationProps) => {
    const { t } = useTranslateLpc(['lpc-pot']);

    return (
        <div className={css.confirmation}>
            <img src="/front-static/icons/display/checkmark-circle-success.svg" alt="success" />
            <h5>{t('invitation.confirmation-title')}</h5>
            <Text variant={'body_02'} color={'txt-secondary'}>
                {t('invitation.confirmation-message')}
            </Text>
            <Button variant={'secondary'} customClass={css.confirmation__cta} onClick={() => onCloseModal()}>
                {t('invitation.back-to-pot')}
            </Button>
        </div>
    );
};

export default Confirmation;
